import { z } from "zod"

export const consumerSchema = z.object({
  fullName: z.string().min(1, "Full Name is required"),
  active: z.string().min(1, "Consumer status is required"),
  address: z.object({
    region: z.coerce.number().min(1, "Region is required"),
    province: z.coerce.number().min(1, "Province is required"),
    municipality: z.coerce.number().min(1, "City is required"),
    barangay: z.coerce.number().min(1, "Barangay is required"),
    postalCode: z
      .string()
      .regex(/^\d+$/, "Postal Code must contain only numbers")
      .min(1, "Postal Code is required"),
    street: z.string().min(1, "Street is required"),
  }),
  latitude: z.coerce
    .number()
    .refine((val) => !isNaN(val), { message: "Latitude is required" })
    .refine((val) => val >= -90 && val <= 90, {
      message: "Latitude must be between -90 and 90",
    })
    .refine((val) => val !== 0, {
      message: "Latitude is required",
    }),
  longitude: z.coerce
    .number()
    .refine((val) => !isNaN(val), { message: "Longitude is required" })
    .refine((val) => val >= -180 && val <= 180, {
      message: "Longitude must be between -180 and 180",
    })
    .refine((val) => val !== 0, {
      message: "Longitude is required",
    }),
  mobileNumber: z
    .string()
    .min(1, "Mobile Number is required")
    .regex(/^[0-9]+$/, "Invalid mobile number"),
  email: z.string().email("Invalid email"),
  connectionTypes: z.string().min(1, "Connection Type is required"),
  zone: z.coerce.number().min(1, "Zone is required"),
  books: z.coerce.number().optional(),
  installationDate: z
    .date()
    .refine(
      (val) => val <= new Date(),
      "Installation date cannot be in the future",
    ),
  meterReader: z.coerce.number().optional(),
  personnelInstalled: z.string(),

  serialNumber: z.string(),
  is_sub_to_email_notif: z.boolean(),
  is_sub_to_paperless_bill: z.boolean(),
  meterInfoId: z.coerce.number().optional(),

  // New Added fields
  serviceFees: z.string(),
  orNumber: z.string(),
  consumptionDeposit: z.string(),
  orDate: z.string(),
  inspectionFee: z.string(),
  laborFee: z.string(),
  other: z.string(),
  remarks: z.string(),
  accountNumber: z.string(),
  cardNumber: z.string(),
})

export const serviceRequestSchema = z.object({
  // Top Section
  invoiceNo: z.string().min(1, "Invoice No is required"),
  applicationDate: z.string().min(1, "Application Date is required"),

  // Consumer Information
  accountNumber: z.string().min(1, "Account Number is required"),
  cardNumber: z.string().min(1, "Card Number is required"),
  fullName: z.string().min(1, "Full Name is required"),
  mobileNumber: z
    .string()
    .regex(/^[0-9]+$/, "Mobile Number must contain only numbers")
    .min(1, "Mobile Number is required"),
  email: z.string().email("Invalid Email"),
  zone: z.coerce.number().min(1, "Zone is required"),
  category: z.string().min(1, "Category is required"),
  completeAddress: z.string().min(1, "Complete Address is required"),

  // Meter Details
  meterNo: z.string().min(1, "Meter Number is required"),
  brand: z.string().min(1, "Brand is required"),
  initialRDG: z.string().min(1, "Initial Reading is required"),
  lastRDG: z.string().min(1, "Last Reading is required"),

  // Complain and Remarks
  complain: z.string().min(1, "Complain is required"),
  remarks: z.string().min(1, "Remarks are required"),
  actionRequired: z.string().min(1, "Action Required is required"),

  // Meter Information Section
  newMeterNumber: z.string().min(1, "New Meter Number is required"),
  newBrand: z.string().min(1, "New Brand is required"),
  size: z.string().min(1, "Size is required"),
  date: z.string().min(1, "Date is required"),
  requestedBy: z.string().min(1, "Requested By is required"),
  preparedBy: z.string().min(1, "Prepared By is required"),
  approvedBy: z.string().min(1, "Approved By is required"),
});